import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import {
    DASHBOARDLIST_PAGE,
    DASHBOARDLIST_SEARCH,
    DASHBOARDLIST_DATE,

} from '../../store/actions/dashboardactions';
import summarybar from './components/summarybar.vue';
import sidebar from './components/sidebar.vue';
import monthview from './components/monthview.vue';
import activitybar from './components/activitybar.vue';
export default {
    name: 'Home',
    inject: ['myEventSignal'],
    components: {
        summarybar,
        sidebar,
        monthview,
        activitybar
    },
    computed: {
        ...mapGetters('auth', [
            'isAdministrator',
            'isAttendant',
            'isClient'
        ]),
        ...mapGetters('dashboardlist', [
            'page',
            'search',
            'date',
        ]),
        getdatename() {
            //let newval = moment(this.date).add(1, 'day').toDate();
            //const formatted = moment(newval).format('dddd D MMMM');
            const raw = moment(this.date).locale('nl').format('dddd'); // "woensdag 1 juli 2026"
            const capitalized = raw.charAt(0).toUpperCase() + raw.slice(1);
            return capitalized;
        },
    },
    data() {
        return {
            initialized: false,
            moment,
        };
    },
    methods: {
        fetch() {
            //const params = {
            //    page: this.page,
            //    search: this.search,
            //    date: this.date,
            //};
            //this.initialized = false;
            //axios.post(APIURL + '/auditreport/list/', params)
            //    .then(resp => {
            //        this.list = resp.data.list;
            //        this.totalPages = resp.data.totalPages;
            //        this.initialized = true;
            //    });
        },
        next(val) {            
            let newval = moment(this.date).add(val, 'day').toDate();
            this.selectDate(newval);
            
        },
      
        ...mapActions('dashboardlist', {
            doSearch: DASHBOARDLIST_SEARCH,
            goToPage: DASHBOARDLIST_PAGE,
            selectDate: DASHBOARDLIST_DATE,
        }),
    }
};